export default __webpack_public_path__ + "static/media/md-card-bg-aiml.3b2a2e24.png";